import React, { useState, useEffect, useContext } from 'react'
import Link from 'gatsby-link'
import resolveLink from 'src/utils/resolveLink'
import SbEditable from 'storyblok-react'
// import Logo from '/static/logo_footer.svg'
import Logo from '/static/logo.svg'
import LogoCondensed from '/static/logo.svg'
import { Popover } from '@headlessui/react'
import MenuItemPopup from './DesktopMenu/MenuItemPopup'
import MobileMenu from './MobileMenu'
import { PageContext } from 'src/utils/context'
import { Button as ButtonReskin } from '@/components/ui/button'
import { SingleColumn } from './New/SingleColumn'
import { TwoColumnsWithAnImage } from './New/TwoColumnsWithAnImage'
import { ThreeColumns } from './New/ThreeColumns'
import { BasicLayout } from './New/BasicLayout'
import { SingleColumnWithImage } from './New/SingleColumnWithImage'

const navigationLayouts = {
  single_column: SingleColumn,
  two_columns_with_an_image: TwoColumnsWithAnImage,
  three_columns: ThreeColumns,
  basic_nav_layout: BasicLayout,
  single_column_with_image: SingleColumnWithImage,
}

const Navigation = ({ settings }) => {
  const { hasHero, location } = useContext(PageContext)
  const [scrolled, setScrolled] = useState(false)
  const [menuOpen, setMenuOpen] = useState(false)

  const handleScroll = () => {
    if (window.scrollY > 50) {
      setScrolled(true)
    } else {
      setScrolled(false)
    }
  }

  useEffect(() => {
    window.addEventListener('scroll', handleScroll)

    if (typeof window !== 'undefined') {
      function handleResize() {
        let vh = window.innerHeight * 0.01
        document.documentElement.style.setProperty('--vh', `${vh}px`)
      }
      window.addEventListener('resize', handleResize)
      handleResize()
      return () => window.removeEventListener('resize', handleResize)
    }
  }, [scrolled])

  const renderNavLayout = (
    layout,
    setMenuOpen,
    menuOpen,
    location,
    noHeroScrolled,
  ) => {
    const Component = navigationLayouts[layout.component]
    return Component ? (
      <Component
        key={layout._uid}
        blok={layout}
        setMenuOpen={setMenuOpen}
        menuOpen={menuOpen}
        location={location}
        noHeroScrolled={noHeroScrolled}
      />
    ) : null
  }

  return (
    <SbEditable content={settings} key={settings._uid}>
      {!hasHero && <div className="pb-[96px] lg:pb-[100px]" />}
      <Popover
        id="navbar"
        // className={`fixed top-0 z-[9999] w-full duration-300 ${
        //   scrolled ? 'bg-white' : ''
        // } ${menuOpen && 'bg-lightblue lg:bg-white'}`}
        className={`fixed top-0 z-[9999] w-full duration-300 ${
          scrolled ? 'bg-white' : ''
        }`}
      >
        <div className="relative">
          <div
            className={`bg-auto mx-auto flex justify-between max-w-[90rem] items-center px-6 duration-300 ${
              scrolled ? 'pt-2 pb-2' : 'p-6 lg:pt-6 lg:pb-6'
            }`}
          >
            {/* Left section with mobile menu and logo */}
            <div className="flex items-center space-x-6 lg:space-x-0">
              {/* Mobile Menu for small screens */}
              <div className="block lg:hidden">
                {/** @INFO: Render mobile nav layout here */}
                {/* {settings.header_navigation.length > 0 && ( */}
                {settings.header_navigation_v2.length > 0 && (
                  <MobileMenu
                    props={settings}
                    scrolled={scrolled}
                    setMenuOpen={setMenuOpen}
                    menuOpen={menuOpen}
                  />
                )}
              </div>
              {/* Logo */}
              <Link
                className="flex w-fit items-center justify-center"
                to={resolveLink('/')}
              >
                <span className="sr-only">Cloud Gateway</span>
                <img
                  className="hidden h-11 sm:block md:block lg:hidden xl:block"
                  src={
                    scrolled
                      ? LogoCondensed
                      : hasHero && !menuOpen
                        ? LogoCondensed
                        : Logo
                  }
                  alt="Cloud Gateway Logo"
                />
                <img
                  className="block h-11 sm:hidden md:hidden lg:block xl:hidden"
                  src={
                    scrolled
                      ? LogoCondensed
                      : hasHero && !menuOpen
                        ? LogoCondensed
                        : LogoCondensed
                  }
                  alt="Cloud Gateway Logo"
                />
              </Link>
            </div>

            {/* Right section with navigation and buttons */}
            <div className="font-display mx-auto flex items-center justify-center space-x-6">
              <Popover.Group
                as="nav"
                className="hidden items-center space-x-6 lg:flex"
              >
                {settings.content.header_navigation_v2.map(item => {
                  if (item.component) {
                    return (
                      <SbEditable content={item} key={item._uid}>
                        {renderNavLayout(
                          item,
                          setMenuOpen,
                          menuOpen,
                          location,
                          !hasHero || scrolled ? true : false,
                        )}
                      </SbEditable>
                    )
                  } else {
                    return (
                      <SbEditable content={item} key={item._uid}>
                        <Link
                          // to={resolveLink(`${item.target.cached_url}`)}
                          to={resolveLink(`${item.target}`)}
                          className={`
                            group font-display font-semibold inline-flex cursor-pointer items-center justify-between py-4 text-sm leading-5 tracking-[-0.02em] outline-none duration-300 focus:outline-none
                            ${
                              !hasHero || scrolled || menuOpen
                                ? 'text-darkblue hover:text-brightgreen'
                                : 'text-darkblue hover:text-white'
                            }
                            ${
                              // location.pathname.includes(item.target.cached_url)
                              location.pathname.includes(item.target)
                                ? '!text-darkblue'
                                : ''
                            }
                            ${
                              location.pathname.includes(
                                // item.target.cached_url,
                                item.target,
                              ) && scrolled
                                ? '!text-brightgreen'
                                : ''
                            }
                          `}
                          target="_blank"
                        >
                          {item.name}
                        </Link>
                      </SbEditable>
                    )
                  }
                })}
              </Popover.Group>
            </div>
            <div className="-mr-2 flex items-center justify-end space-x-2">
              <ButtonReskin
                variant="tertiary_blue"
                className={`hidden md:block text-darkblue'`}
                to={settings.content.header_button_portal_link}
                before={settings.content.header_button_portal_text}
              >
                {settings.content.header_button_portal_text}
              </ButtonReskin>
              <ButtonReskin
                to={settings.content.header_button_target}
                before={settings.content.header_button_text}
              >
                {settings.content.header_button_text}
              </ButtonReskin>
              {/* Desktop menu */}
              <div className="hidden lg:block">
                {settings.header_navigation.length > 0 && (
                  <MobileMenu
                    props={settings}
                    scrolled={scrolled}
                    setMenuOpen={setMenuOpen}
                    menuOpen={menuOpen}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </Popover>
    </SbEditable>
  )
}

export default Navigation
